import { Button } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import * as React from 'react';
import { connect } from 'react-redux';
import { Actions as Router, Selectors } from 'router';
import { State } from 'store';

interface StateProps {
  siteId: string;
}

interface DispatchProps {
  push: (href: string) => void;
}

type Props = StateProps & DispatchProps;

export const Header: React.FC<Props> = (props: Props) => {
  const newSplitTest = () => {
    props.push(`/sites/${props.siteId}/campaigns/split_tests/create/settings`);
  };

  return (
    <AppTopBar>
      <Button variation="primary" onClick={newSplitTest}>
        New
      </Button>
    </AppTopBar>
  );
};

const mapState = (state: State): StateProps => {
  return {
    siteId: Selectors.getSiteId(state),
  };
};

const actions: DispatchProps = {
  push: Router.push,
};

export default connect(mapState, actions)(Header);
